import { connect } from 'react-redux';

import { toggleOlxProPopup } from '../../core/actions';
import Characteristics from './Characteristics';


export default connect(null, { openModal: toggleOlxProPopup })(Characteristics);
